import React from 'react';
import { HeroCarousel } from '../components/home/HeroCarousel';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { LatestProjects } from '../components/home/LatestProjects';
import { Catalogs } from '../components/home/Catalogs';
import { Reviews } from '../components/home/Reviews';
import { CtaSection } from '../components/home/CtaSection';
import { Seo } from '../components/Seo';
import { seoPages, localBusinessJsonLd } from '../seo';

const Home = () => (
  <div className="min-h-screen bg-[#000000]">
    <Seo title={seoPages.home.title} description={seoPages.home.description} jsonLd={localBusinessJsonLd} />
    <HeroCarousel />
    <WhyChooseUs />
    <ServicesGrid />
    <LatestProjects />
    <Catalogs />
    <Reviews />
    <CtaSection />
  </div>
);

export default Home;
